'use strict';

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

require('../modules/breakpoints');

var _cart = require('../modules/cart');

var _cart2 = _interopRequireDefault(_cart);

var _imageLazyload = require('../modules/image-lazyload');

var _imageLazyload2 = _interopRequireDefault(_imageLazyload);

var _rteWrappers = require('../modules/rte-wrappers');

var _rteWrappers2 = _interopRequireDefault(_rteWrappers);

var _limelightAccordions = require('../modules/limelight-accordions');

var _limelightAccordions2 = _interopRequireDefault(_limelightAccordions);

var _limelightSelects = require('../modules/limelight-selects');

var _limelightSelects2 = _interopRequireDefault(_limelightSelects);

var _stickyHeader = require('../modules/sticky-header');

var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

var _cards = require('../modules/cards');

var _cards2 = _interopRequireDefault(_cards);

var _scrollState = require('../modules/scroll-state');

var _scrollState2 = _interopRequireDefault(_scrollState);

var _easeIn = require('../modules/ease-in');

var _easeIn2 = _interopRequireDefault(_easeIn);

var _currency = require('../modules/currency');

var _currency2 = _interopRequireDefault(_currency);

var _ajaxinate = require('../modules/ajaxinate');

var _ajaxinate2 = _interopRequireDefault(_ajaxinate);

var _limelight = require('@dotdev/limelight');

var _limelight2 = _interopRequireDefault(_limelight);

var _shopifyCart = require('shopify-cart');

var _shopifyCart2 = _interopRequireDefault(_shopifyCart);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeSections = require('@shopify/theme-sections');

require('../sections/theme-announcements');

require('../sections/theme-header');

require('../sections/theme-footer');

require('../sections/theme-popups');

require('../sections/index-collections');

require('../sections/index-products');

require('../templates/customers/account');

require('../templates/customers/account.orders');

require('../templates/customers/account.wishlist');

require('../templates/customers/addresses');

require('../templates/customers/login');

require('../templates/customers/order');

require('../templates/customers/register');

require('../modules/injectIcon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global vars


// Customer sections


// Scripts
/**
 * -----------------------------------------------------------------------------
 * Theme Layout
 * -----------------------------------------------------------------------------
 */

// Styles
window.theme = window.theme || {};

// Inject Icon Handler


// Shopify sections api

window.$ = _jquery2.default;
window.jQuery = _jquery2.default;
window.Ajaxinate = _ajaxinate2.default;
window.Limelight = _limelight2.default;
window.Cart = _shopifyCart2.default;
window.easeIntoView = _easeIn2.default;
window.cardHeights = _cards2.default;

// Load sections
(0, _themeSections.load)(['theme-announcements', 'theme-header', 'theme-footer', 'theme-popups', 'index-collections', 'index-products']);

// Init on doc ready
document.addEventListener('DOMContentLoaded', function () {
  (0, _imageLazyload2.default)();
  (0, _rteWrappers2.default)();
  (0, _limelightAccordions2.default)();
  (0, _limelightSelects2.default)();
  (0, _stickyHeader2.default)();
  (0, _cards2.default)();
  (0, _scrollState2.default)();
  (0, _easeIn2.default)();
  (0, _currency2.default)();
  (0, _cart2.default)();
});